<template>
    <div class="h-full w-full">
        <wrapper-widget-table ref="widgetTable" :reportData="reportData" @updateReportData="updateReportData" />
    </div>
</template>

<script>
import WrapperWidgetTable from '@/modules/reports/components/WrapperWidgetTable.vue'

export default {
    props: {
        reportData: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        WrapperWidgetTable
    },
    methods: {
        updateReportData (data) {
            this.$emit('updateReportData', data)
        }
    }
}
</script>
